import { call, put, takeEvery } from "redux-saga/effects";
import { sagaTypes } from "./types";
import { IData, IDataPage } from "../../interfaces/common";
import { IAction } from "../utils";
import { getOffer, getOffers } from "../../api/offers";
import {
  getMoreOffersAction,
  getOfferAction,
  getOffersAction,
  setSizePageAction,
} from "./action";
import { IOffer } from "../../interfaces/offer";

export function* getOffersWorkerSaga({ payload }: IAction<string>) {
  const res: IDataPage<IOffer[]> = yield call(getOffers, payload as string);
  yield put(getOffersAction(res?.data?.items || []));
  if (res?.data) {
    const { pageSize, totalPages, totalCount, pageIndex } = res?.data;
    yield put(
      setSizePageAction({ pageSize, totalPages, totalCount, pageIndex })
    );
  }
}

export function* getMoreOffersWorkerSaga({ payload }: IAction<string>) {
  const res: IDataPage<IOffer[]> = yield call(getOffers, payload as string);
  yield put(getMoreOffersAction(res?.data?.items || []));
  if (res?.data) {
    const { pageSize, totalPages, totalCount, pageIndex } = res?.data;
    yield put(
      setSizePageAction({ pageSize, totalPages, totalCount, pageIndex })
    );
  }
}

export function* getOfferWorkerSaga({ payload }: IAction<string>) {
  const res: IData<IOffer> = yield call(getOffer, payload as string);
  yield put(getOfferAction(res?.data));
}

export function* offersWatcherSaga() {
  yield takeEvery(sagaTypes?.GET_ALL_OFFERS, getOffersWorkerSaga);
  yield takeEvery(sagaTypes?.GET_MORE_OFFERS, getMoreOffersWorkerSaga);
  yield takeEvery(sagaTypes?.GET_OFFER, getOfferWorkerSaga);
}
